var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcVoice16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zM5 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0zM9 4a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0zM13 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0z"
})));
export default SvgIcVoice16;